// extracted by mini-css-extract-plugin
export default {"container":"CM-z"};